import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import Menu from '../containers/parts/menu';
import Search from './search';

class Header extends Component {
    render() {
        return (
            <div className="ad-block-wrapper">
				<iframe src="https://marshallton.chestercountykiosk.com/kiosk-ads" width="1080" height="225" className="ad-block-iframe" scrolling="no"/>
			</div>
        );
    }
}

module.exports = Header;



// WEBPACK FOOTER //
// ./src/components/header.js